import { Card, Flex, Tag, Tooltip } from 'antd'
import { t } from 'i18next'
import React, { useContext } from 'react'
import BoxContext from './BoxContext'
import dayjs from 'dayjs'

const DateTag = ({ state, date, format }) => {
  return (
    <Tooltip placement="top" title={t(`Admin.Appointment.state.${state}`)} >
      <Tag color={t(`Admin.Appointment.stateColor.${state}`)} variant='solid'
        style={{ marginRight: '1em', marginBottom: '0.5em' }}> {dayjs(date).format(`${format}`)}
      </Tag>
    </Tooltip>
  )
}

export default function BoxCleaningPage () {
  const { box } = useContext(BoxContext)

  const appointmentList = (appointments) => {
    return appointments.map((ap) => (
      <div key={ap.date}>
        <DateTag state={ap.state} date={ap.date} format={'dddd HH:mm'} />
        {ap.name}
      </div>
    ))
  }

  const countColor = (limit, count) => {
    if (count < Math.round(limit * 0.75)) {
      return 'green'
    } else if (count < limit) {
      return 'orange'
    } else {
      return 'red'
    }
  }

  const slotsCountColor = (count) => (countColor(box.cleaning_slots_limit, count))
  const appointmentsCountColor = (count) => (countColor(box.cleaning_appointments_limit, count))

  const styles = { body: { display: 'flex', justifyContent: 'center' } }
  const cardStyle = { marginBottom: '1em' }

  const countStyles = ({ color }) => (
    { body: { ...styles.body, fontSize: '30px', fontWeight: 'bold', color } }
  )

  return (
    <>
      {box &&
        <Flex justify='space-around' style={{ marginTop: '1em' }} wrap>
          <Card title={t('Admin.BoxCleaningPage.last_cleaning_informations')}
            style={cardStyle} styles={styles}>
            {box.cleaning_informations.last.date &&
              <DateTag state={'done'} date={box.cleaning_informations.last.date} format={'DD/MM/YYYY HH:mm'} />
            }
            {box.cleaning_informations.last.name}
          </Card>
          <Card title={t('Admin.BoxCleaningPage.appointments_count')} style={cardStyle}
            styles={countStyles({ color: appointmentsCountColor(box.cleaning_informations.appointments_count) })}
          >
            {box.cleaning_informations.appointments_count}
          </Card>
          <Card title={t('Admin.BoxCleaningPage.slots_count')} style={cardStyle}
            styles={countStyles({ color: slotsCountColor(box.cleaning_informations.slots_count) })}
          >
            {box.cleaning_informations.slots_count}
          </Card>
          <Card title={t('Admin.BoxCleaningPage.next_cleaning_informations')} style={cardStyle} styles={styles}>
            {box.cleaning_informations.next.date &&
              <DateTag state={'waiting'} date={box.cleaning_informations.next.date} format={'DD/MM/YYYY HH:mm'} />
            }
            {box.cleaning_informations.next.name}
          </Card>
          <Card title={t('Admin.BoxCleaningPage.week_cleaning_informations')} style={cardStyle} styles={styles}>
            {box.cleaning_informations.week_appointments.length > 0 &&
              <Flex vertical>
                {appointmentList(box.cleaning_informations.week_appointments)}
              </Flex>
            }
            {box.cleaning_informations.week_appointments.length === 0 && 'Aucun RDV prévu cette semaine'}
          </Card>
        </Flex>
      }
    </>
  )
}
